import { useState, useEffect, Dispatch, SetStateAction} from "react";
import { EModalOkType as EModalOkCancelType } from "./ModalOKEnums";
import ModalOKCSS from "./ModalOKCSS";

interface IProps { 
  title: string,
  text: string,
  type?: EModalOkCancelType,
}

interface ISetContentAndShow {
  isOkCancel?: boolean,
  type?: EModalOkCancelType,
  title?: string,
  text?: string,
  fConfirm?: () => void;
  fCancel?: () => void;
}

export interface IModalOkCancelControllerReturn {
  //statesContent
  title: string | Nude; setTitle: Dispatch<SetStateAction<string | Nude>>;
  text: string | Nude; setText: Dispatch<SetStateAction<string | Nude>>;
    
  //stateType
  type: EModalOkCancelType; setType: Dispatch<SetStateAction<EModalOkCancelType>>;
  isOkCancel: boolean,

  //stateActions
  show: boolean; setShow: Dispatch<SetStateAction<boolean>>;
  result: boolean | undefined; setResult: Dispatch<SetStateAction<boolean | undefined>>;

  css: string

  //functions
  setContentAndShow(props:ISetContentAndShow): void
}


// class FConfirm {

//   public static setFConfirm(f: (() => void) | undefined) {
//     this.fConfirm = f ? ()=> { f(); } : () => {};
//   }
//   public static fConfirm: () => void = () => {}
//   public static reset() {
//     this.fConfirm = () => {}
//   }
// }

class ModalOKService {

  public static fCancel: (() => void) | undefined = undefined
  public static setFCancel(f: (() => void) | undefined) {
    this.resetFCancel();
    this.fCancel = f;
  }
  public static resetFCancel() {
    this.fCancel = undefined
  }

  public static fConfirm: (() => void) | undefined = undefined
  public static setFConfirm(f: (() => void) | undefined) {
    this.resetFConfirm();
    this.fConfirm = f;
  } 
  public static resetFConfirm() {
    this.fConfirm = undefined
  }
}


  

export const ModalOkCancelController = (props: IProps): IModalOkCancelControllerReturn => {

    const tag = "ModalOkCancelController"
    //console.log(tag + "START")

    //#region states
    const [show, setShow] = useState<boolean>(false);      

    const [result, setResult] = useState<boolean | undefined>(undefined)
    useEffect(() => {
      if(result == undefined) return;

      if(result == true) { 
        ModalOKService.fConfirm?ModalOKService.fConfirm():{};
        ModalOKService.resetFConfirm()
        return;
      } 
      
      if(result == false) {
        ModalOKService.fCancel?ModalOKService.fCancel():{};
        ModalOKService.resetFCancel()
      }
    }, [result]);

    //public static getUsers({size = 64, items = null}: Partial<IGetUsersProps> = {}): JSX.Element {
    function setContentAndShow(props: ISetContentAndShow) {
      setResult(undefined);
      setIsOkCancel(props.isOkCancel ? props.isOkCancel : false);
      setType(props.type ? props.type : EModalOkCancelType.Error);
      setTitle(props.title ? props.title : (""));
      setText(props.text);

      //fConfirm = new FConfirm(props.fConfirm)
      //fConfirm = ()=> { props.fConfirm?props.fConfirm():{} }
      
      //fConfirm = props.fConfirm
      //setFConfirm(props.fConfirm)
    
      ModalOKService.setFConfirm(props.fConfirm);
      ModalOKService.setFCancel(props.fCancel);
      setShow(true);
    }

    const [text, setText] = useState<string | Nude>(props.text);  
    const [title, setTitle] = useState<string | Nude>(props.title); 

    const [isOkCancel, setIsOkCancel] = useState<boolean>(false); 
    //useEffect(() => { }, [isOkCancel]);
    const [type, setType] = useState<EModalOkCancelType>(props.type?props.type:EModalOkCancelType.Error); 
    useEffect(() => {
      setCSS(getCSS())
    }, [type]);

    const getCSS = (): string => {
      switch(type) {
        case EModalOkCancelType.Success: return ModalOKCSS.typeSuccess;
        case EModalOkCancelType.Info: return ModalOKCSS.typeInfo;
        case EModalOkCancelType.Warning: return ModalOKCSS.typeWarning;
        case EModalOkCancelType.Error: return ModalOKCSS.typeError;
        default: return ModalOKCSS.typeInfo
      }
    }
    const [css, setCSS] = useState<string>(getCSS()); 
    //#endregion


    //#region init
    useEffect(() => {
      setCSS(getCSS());

      return () => {
        ModalOKService.resetFConfirm()//???
      }
    }, []);
    //#endregion
    

    return {
      //states
      title, setTitle,
      text, setText,
      show, setShow,
      
      type, setType,
      isOkCancel,
      
      result, setResult,

      //functions
      css,
      setContentAndShow
    }
}